import { defineStore } from 'pinia';
import { io } from 'socket.io-client';
import { API_URL } from '../../api-config';

export const useSocketStore = defineStore('socket', {
  state: () => ({
    socket: null,
    connected: false,
  }),

  actions: {
    // Inicializa o socket
    initializeSocket() {
      this.socket = io(API_URL);

      // Escuta eventos básicos de conexão
      this.socket.on('connect', () => {
        console.log('Conectado ao servidor WebSocket');
        this.connected = true;
      });

      this.socket.on('disconnect', () => {
        console.log('Desconectado do servidor WebSocket');
        this.connected = false;
      });
    },

    // Envia uma mensagem ao servidor
    sendMessage(event, data) {
      if (this.socket) {
        this.socket.emit(event, data);
      }
    },

    // Registra um ouvinte para eventos específicos
    onEvent(event, callback) {
      if (this.socket) {
        this.socket.on(event, callback);
      }
    },

    // Remove um ouvinte específico
    offEvent(event) {
      if (this.socket) {
        this.socket.off(event);
      }
    },

    // Finaliza a conexão com o socket
    disconnectSocket() {
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
        this.connected = false;
      }
    },
  },
});